(() => {
  function initialize(section) {
    if (section.dataset.cvRelatedReady === 'true') return;
    const track = section.querySelector('[data-cv-related-track]');
    const previous = section.querySelector('[data-cv-related-prev]');
    const next = section.querySelector('[data-cv-related-next]');
    if (!track || !previous || !next) return;
    section.dataset.cvRelatedReady = 'true';

    const update = () => {
      const remaining = track.scrollWidth - track.clientWidth;
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= remaining - 2;
      section.classList.toggle('cv-cpb-related--static', remaining <= 2);
    };
    const advance = (direction) => {
      const card = track.querySelector('.cv-cpb-related__card');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const distance = (card ? card.getBoundingClientRect().width + gap : track.clientWidth) * direction;
      track.scrollBy({ left: distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };

    previous.addEventListener('click', () => advance(-1));
    next.addEventListener('click', () => advance(1));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    track.querySelectorAll('img').forEach((image) => image.addEventListener('load', update, { once: true }));
    update();
  }

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-cv-cpb-related]').forEach(initialize);
    if (root.matches && root.matches('[data-cv-cpb-related]')) initialize(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
